import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { get } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function DpoBanner() {
  const { user } = useAuth();
  const admin = user?.role === "super_admin";
  const { data } = useQuery({ queryKey: ["privacy-settings"], queryFn: () => get("/settings/privacy"), enabled: admin, staleTime: 300_000 });
  if (!admin || !data || (data.dpo_name && data.dpo_email)) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-[#E8D9B5] bg-caution-tint px-6 py-2 text-sm text-caution lg:px-10" role="status" data-testid="dpo-missing-banner">
      <ShieldAlert size={16} aria-hidden="true" /> No Data Protection / Grievance Officer is set. DPDP requires this contact in your candidate privacy notice.
      <Link to="/app/settings/privacy" className="font-medium underline" data-testid="dpo-banner-link">Add it now</Link>
    </div>
  );
}
